export default function ($resource, $http, $location, flashService, $sanitize, $rootScope) {

  var loginError = function (response) {//called when error occurs with login and tells user.
    console.log(response);
    flashService.show(response.flash);
  };

  var sanitizeCredentials = function (credentials) {
    return {
      email: $sanitize(credentials.email),
      password: $sanitize(credentials.password),
      remember_me: $sanitize(credentials.remember_me)
      //csrf_token: CSRF_TOKEN
    };
  };

  return {
    login: function (credentials) {
      var login = $http.post("/auth/login", sanitizeCredentials(credentials));
      login.then(function (data) {

      }, function (data) {

      });
      return login;
    },
    adminlogin: function (credentials) {
      var adminlogin = $http.post("/auth/adminlogin", sanitizeCredentials(credentials));
      adminlogin.then(function (data) {

      }, function (data) {
        //loginError(data);
      });
      //adminlogin.error(loginError);
      return adminlogin;
    },
    logout: function (current) {
      var logout = $http.get('/auth/logout');
      return logout;
    },
    cutoffcheck: function (credentials) {
      var cutoffcheck = $http.post('/auth/cutoffcheck', sanitizeCredentials(credentials));
      return cutoffcheck;
    },
    isLogged: function () {//Checks for cookie
      var isLogged = $http.get("/auth/cookieStatus");
      return isLogged;
    },
    getUser: function () {//Check users status, if logged, return info
      var getUser = $http.get("/auth/secrets");
      getUser.success(function (data) {

      });
      return getUser;
    },
    getUserCookie: function () {
      var getUserCookie = $http.get("/auth/secrets");

      getUserCookie.then(function (data) {

      }, function (data) {

      });
      return getUserCookie;
    },
    getRedirectCookie: function () {
      var getRedirectCookie = $http.get("/auth/get-redirect");
      getRedirectCookie.success(function (data) {
      }, function (data) {

      });
      return getRedirectCookie;
    },
    setRedirectCookie: function () {
      var setRedirectCookie = $http.get("/auth/set-redirect");
      setRedirectCookie.success(function (data) {

      }, function (data) {

      });
      return setRedirectCookie;
    },
    redirectUser: function () {
      var redirectUser = $http.get("/auth/redirect-user");
      redirectUser.success(function (data) {

      }, function (data) {

      });
      return redirectUser;
    },
    isAuthenticated: function () {
      return !!$rootScope.currentUser.id;
    },
    isAuthorized: function (authorizedRoles) {
      if (!angular.isArray(authorizedRoles)) {
        authorizedRoles = [authorizedRoles];
      }
      //return (!!$rootScope.currentUser.id && authorizedRoles.indexOf($rootScope.currentUser.acc_type) !== -1);
      return (authorizedRoles.indexOf($rootScope.currentUser.acc_type) !== -1);
    },
    accessCheck: function (category) {
      var accessCheck = $http.post("/auth/accessCheck", category);
      accessCheck.success(function (data) {

      });
      return accessCheck;
    },
    changeBack: function () {
      return $http.get("/auth/success");
    },
    infoEmail: function (credentials) {
      var infoEmail = $http.post("/auth/infoEmail", credentials);
      infoEmail.success(function (data) {

      });
      return infoEmail;
    },
    tutorial1: function () {
      var tutorial1 = $http.get("/users/tutorial1");
      tutorial1.success(function (data) {
        //console.log(data);
      });
      return tutorial1;
    },
    tutorial2: function () {
      var tutorial2 = $http.get("/users/tutorial2");
      tutorial2.success(function (data) {
        //console.log(data);
      });
      return tutorial2;
    },
    isReportAuthenticated: function () {
      var isReportAuthenticated = $http.get("/auth/report");
      isReportAuthenticated.success(function (data) {

      });
      return isReportAuthenticated;
    },
    isDevAuthenticated: function () {
      var isDevAuthenticated = $http.get("/auth/devapp");
      isDevAuthenticated.success(function (data) {

      });
      return isDevAuthenticated;
    }

  };
};


// WEBPACK FOOTER //
// ./client/services/Authentication.js